import { Typography } from '@mui/material';

const SectionLabel = ({ children }: { children: string }) => (
  <Typography
    variant="subtitle2"
    color="text.secondary"
    sx={{ marginTop: 3, marginBottom: 1, textTransform: 'uppercase', letterSpacing: '0.04em' }}
  >
    {children}
  </Typography>
);

export default SectionLabel;
